import PropTypes from 'prop-types';
import cn from 'classnames';

require('./mobileBottom.scss');

export default function MobileBottom ({buttons=[],
                                       className=''
}) {

  const createButton = (button) => {
    if (!button) {
      return null;
    }
    const {id, action, actionData, className, label, ...other } = button;
    return (
      <div
        {...other}
        key={id}
        id={id}
        className={cn('mobile-bottom-item', className ?? '')}
        onClick={() => {action?.(actionData)}}
      >
        <span>{label}</span>
      </div>);
  };

  return (
    <div className={cn('mobile-bottom', className)}>
      {buttons.map(b => createButton(b))}
    </div>
  );
}

MobileBottom.propTypes = {
  buttons: PropTypes.array,
  className: PropTypes.string,
};


